// src/components/Footer.jsx

import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import { SupportAgent, Send as TelegramIcon } from '@mui/icons-material';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const handleSupportClick = () => {
    window.open('https://t.me/CardsPay_Support', '_blank');
  };

  return (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bgcolor: '#FFFFFF',
        borderTop: '1px solid #E2E8F0',
        mt: 'auto',
        py: 3,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          {/* Copyright */}
          <Typography variant="body2" sx={{ color: '#64748B' }}>
            © {currentYear} CardsPay. All rights reserved.
          </Typography>

          {/* Support Button */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button
              onClick={handleSupportClick}
              startIcon={<SupportAgent />}
              endIcon={<TelegramIcon />}
              variant="contained"
              sx={{
                background: 'linear-gradient(45deg, #0088CC 30%, #00AAFF 90%)',
                color: 'white',
                px: 3,
                py: 1,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
                boxShadow: '0 4px 14px rgba(0, 136, 204, 0.3)',
                '&:hover': {
                  background: 'linear-gradient(45deg, #006699 30%, #0088CC 90%)',
                  boxShadow: '0 6px 20px rgba(0, 136, 204, 0.4)',
                }
              }}
            >
              Contact Support
            </Button>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
}
